import { config, handleResponse } from '../../_helpers';

export const hustlingServices = {
    getVoyageListingHustling,

    // GET
    loadHustlingByBranch,
    readHustlingHeaderByVoyageNum,
    getHustlingCode,

    // POST
    createHustling,

    // PUT
    updateHustling,

    // DELETE
    deleteHustling,
}

function getVoyageListingHustling(branchCode, search) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(branchCode),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    
    if(search){
        return fetch(`${config.apiUrl}/Hustlings/getVoyageListingHustling?search=${search}`, requestOptions).then(handleResponse);
    }
    else{
        return fetch(`${config.apiUrl}/Hustlings/getVoyageListingHustling`, requestOptions).then(handleResponse);
    }
}

function loadHustlingByBranch(branch, skip, take, search) {
    const requestOptions = {
        method: 'GET'
    };
    // if(search){
    //     return fetch(`${config.apiUrl}/Hustlings/loadHustlingByBranch?branch=${branch}&skip=${skip}&take=${take}&search=${search}`, requestOptions).then(handleResponse);
    // }
    // else{
    //     return fetch(`${config.apiUrl}/Hustlings/loadHustlingByBranch?branch=${branch}&skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    // }
    if(search){
        return fetch(`${config.apiUrl}/Hustlings/loadHustlingByBranchV1?branch=${branch}&skip=${skip}&take=${take}&search=${search}`, requestOptions).then(handleResponse);
    }
    else{
        return fetch(`${config.apiUrl}/Hustlings/loadHustlingByBranchV1?branch=${branch}&skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}

function readHustlingHeaderByVoyageNum(voyage, branch, skip, take, search) {
    const requestOptions = {
        method: 'GET'
    };
    if(search){
        return fetch(`${config.apiUrl}/Hustlings/readHustlingHeaderByVoyageNum/${voyage}?branch=${branch}&skip=${skip}&take=${take}&search=${search}`, requestOptions).then(handleResponse);
    }
    else{
        return fetch(`${config.apiUrl}/Hustlings/readHustlingHeaderByVoyageNum/${voyage}?branch=${branch}&skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}
function getHustlingCode(hustlingCode) {
    const requestOptions = {
        method: 'GET'
    };
    // return fetch(`${config.apiUrl}/Hustlings/getHustlingCode/${hustlingCode}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/Hustlings/getHustlingCodeV1/${hustlingCode}`, requestOptions).then(handleResponse);
}

function createHustling(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/Hustlings/createHustling`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/Hustlings/createHustlingData`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/Hustlings/createHustlingDataV1`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/Hustlings/createHustlingDataV2`, requestOptions).then(handleResponse);
}

function updateHustling(payload, hustlingCode) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/Hustlings/updateHustling/${hustlingCode}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/Hustlings/updateHustlingData/${hustlingCode}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/Hustlings/updateHustlingDataV1/${hustlingCode}`, requestOptions).then(handleResponse);
}

function deleteHustling(selected) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(selected),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Hustlings/deleteHustling`, requestOptions).then(handleResponse);
}